import { useState } from "react";
import { CloseOutlined, ShopOutlined, CheckCircleOutlined, LoadingOutlined } from "@ant-design/icons";

export default function TransferBranchModal({ branches, onClose, onTransfer, isTransferring, currentBranchId }) {
  const [selectedBranchId, setSelectedBranchId] = useState(currentBranchId || null);

  const handleTransfer = () => {
    if (selectedBranchId) {
      onTransfer(selectedBranchId);
    }
  };

  return (
    <div 
      className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" 
      style={{ zIndex: 10000 }}
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="relative px-6 py-4 border-b border-slate-200 bg-gradient-to-r from-slate-50 to-white">
          <button
            onClick={onClose}
            disabled={isTransferring}
            className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-slate-900 text-white transition-all hover:bg-slate-800 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <CloseOutlined className="text-sm" />
          </button>

          <div className="pr-10">
            <h2 className="text-xl font-bold text-slate-900">Transfer Branch</h2>
            <p className="text-sm text-slate-500 mt-1">Select a branch to transfer this order</p>
          </div>
        </div>

        {/* Branches List */}
        <div className="p-4 max-h-[60vh] overflow-y-auto">
          {!branches || branches.length === 0 ? (
            <div className="py-12 text-center">
              <ShopOutlined className="text-4xl text-slate-300 mb-3" />
              <p className="text-slate-500 font-medium">No branches available</p>
              <p className="text-sm text-slate-400 mt-1">Please add branches to continue</p>
            </div>
          ) : (
            <div className="space-y-2">
              {branches.map((branch) => {
                const isSelected = selectedBranchId === branch.Id;
                const isCurrent = currentBranchId === branch.Id;

                return (
                  <button
                    key={branch.Id}
                    onClick={() => setSelectedBranchId(branch.Id)}
                    disabled={isTransferring || isCurrent}
                    className={`
                      w-full flex items-center gap-4 p-3 rounded-xl border-2 transition-all
                      ${
                        isSelected
                          ? "border-green-500 bg-green-50 shadow-md"
                          : isCurrent
                          ? "border-slate-300 bg-slate-100 cursor-not-allowed"
                          : "border-slate-200 bg-white hover:border-slate-300 hover:shadow-sm"
                      }
                      disabled:opacity-50 disabled:cursor-not-allowed
                    `}
                  >
                    {/* Branch Icon */}
                    <div
                      className={`
                      w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg
                      ${
                        isSelected
                          ? "bg-green-500 text-white"
                          : isCurrent
                          ? "bg-slate-300 text-slate-600"
                          : "bg-slate-100 text-slate-600"
                      }
                    `}
                    >
                      <ShopOutlined className="text-2xl" />
                    </div>

                    {/* Branch Info */}
                    <div className="flex-1 text-left">
                      <p className={`font-semibold ${isSelected ? "text-green-900" : isCurrent ? "text-slate-500" : "text-slate-900"}`}>
                        {branch.Name}
                      </p>
                      {/* <p className="text-xs text-slate-500">ID: {branch.Id}</p> */}
                    </div>

                    {/* Selection Indicator */}
                    {isSelected && (
                      <CheckCircleOutlined className="text-2xl text-green-500" />
                    )}
                  
                  </button>
                );
              })}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-slate-200 bg-slate-50 flex gap-3">
          <button
            onClick={onClose}
            disabled={isTransferring}
            className="flex-1 px-4 py-2.5 rounded-lg border-2 border-slate-300 text-slate-700 font-semibold hover:bg-slate-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={handleTransfer}
            disabled={!selectedBranchId || selectedBranchId === currentBranchId || isTransferring}
            className="flex-1 px-4 py-2.5 rounded-lg bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold hover:from-green-600 hover:to-green-700 transition-all shadow-md disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {isTransferring ? (
              <>
                <LoadingOutlined className="animate-spin" />
                Transferring...
              </>
            ) : (
              "Transfer Order"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}